import React, { useContext, useState } from "react";

import Spinner from "../../../atoms/Spinner";
import { Context } from "../../../studentStore";
import useCategorizeMaterials from "../../../hooks/useCategorizeMaterials";

import SchoolLevelSection from "./SchoolLevelSection";
import styles from "./NavigationVideosPage.module.scss";

const NavigationVideosPage = () => {
  const { state } = useContext(Context);
  const [playingLessonVideoId, setPlayingLessonVideoId] = useState<
    number | null
  >(null);

  const categorizedMaterials = useCategorizeMaterials(
    state.navigationVideos ?? [],
  );

  if (state.navigationVideos === null) {
    return (
      <div className={styles.loading}>
        <Spinner spinColor="black" />
      </div>
    );
  }

  const schoolLevels = [
    {
      key: "middle",
      label: "中学",
      materials: categorizedMaterials.middle,
    },
    {
      key: "high",
      label: "高校",
      materials: categorizedMaterials.high,
    },
  ];

  const hasMaterials = schoolLevels.some(
    schoolLevel => schoolLevel.materials.length > 0,
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.inner}>
          <p className={styles.title}>ナビ動画</p>
          <p className={styles.description}>
            vol.ごとの学習動画一覧です。中学・高校を切り替えて、見たいvol.の動画を選んでください。
          </p>
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.content}>
          {hasMaterials ? (
            schoolLevels.map(
              schoolLevel =>
                schoolLevel.materials.length > 0 && (
                  <SchoolLevelSection
                    key={schoolLevel.key}
                    label={schoolLevel.label}
                    materials={schoolLevel.materials}
                    onVideoPlay={setPlayingLessonVideoId}
                    playingLessonVideoId={playingLessonVideoId}
                  />
                ),
            )
          ) : (
            <p className={styles.emptyMessage}>
              現在、視聴できるナビ動画はありません。
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default NavigationVideosPage;
